// INV38 (docs/build-briefs/INV38-hide-set-starting-stock-row-when-done.md): the one
// signal that says "whether every item has starting stock may have changed". The api
// layer raises it after a count closes, after starting stock is saved, and after an item
// is created; the account menu listens and re-reads the status. DOM-free, so the api
// module can import it without pulling in a screen.

let listener: (() => void) | undefined;

/** Registers the single listener (the account menu). A later call replaces it. */
export function onStartingStockMayHaveChanged(next: (() => void) | undefined): void {
  listener = next;
}

/** Raised by the api layer after a successful write that can change the answer. */
export function noteStartingStockMayHaveChanged(): void {
  listener?.();
}

/** Wraps a request so the signal is raised when it comes back 2xx. Generic over the whole
 * promise so the caller's declared result type flows through to the request. */
export function signalOnSuccess<T extends { status: number }>(request: Promise<T>): Promise<T> {
  return request.then((result) => {
    if (result.status >= 200 && result.status < 300) {
      noteStartingStockMayHaveChanged();
    }
    return result;
  });
}
